import { NgModule, ErrorHandler } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MainComponent } from './main.component';
import { MainRoutingModule } from './main-routing.module';
import { SharedModule } from '@shared/modules';
import { IonicModule } from '@ionic/angular';
import { MatNativeDateModule } from '@angular/material/core';

import { FeaturesComponent } from './features/features.component';
import { AppHintComponent, AchievementComponent } from '@shared/components';
// import { ProgressBarComponent } from '@shared/components/progress-bar/progress-bar.component';

import { ToolbarComponent, FooterComponent } from '@shared/ui';

import { NavigationModule } from '@shared/components/navigation/navigation.module';

import { UtilityService, DynamicScriptLoaderService } from '@shared/utilities';

import {
  AppHintService,
  GameMenuService,
  BreakPointsService,
  DialogHandlerService,
  FullscreenService,
  CompaniesService,
  CertificatesService,
  ProgramsService,
  AdminGuard,
  AdminSiteGuard,
  CompanyAdminGuard,
  HttpResponseHandleService,
  DemoProgramService,
  RequestCacheService,
  AchievementSystemService,
  SubProgramService,
  GlobalErrorHandler,
  HttpErrorInterceptor,
  LoadScriptResolver,
  GTagService,
  SpeechService,
  SpeechPlayService,
  PlaceholderService,
} from '@shared/services';

@NgModule({
  declarations: [
    MainComponent,
    AppHintComponent,
    AchievementComponent,
    ToolbarComponent,
    FeaturesComponent,
    FooterComponent,
  ],
  imports: [
    IonicModule.forRoot(),
    MatNativeDateModule,
    MainRoutingModule,
    NavigationModule,
    SharedModule,
  ],
  exports: [MainComponent],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    DynamicScriptLoaderService,
    HttpResponseHandleService,
    AchievementSystemService,
    DialogHandlerService,
    CertificatesService,
    RequestCacheService,
    DemoProgramService,
    BreakPointsService,
    LoadScriptResolver,
    PlaceholderService,
    SubProgramService,
    CompanyAdminGuard,
    SpeechPlayService,
    FullscreenService,
    CompaniesService,
    GameMenuService,
    ProgramsService,
    AdminSiteGuard,
    UtilityService,
    AppHintService,
    SpeechService,
    GTagService,
    AdminGuard,
  ],
})
export class MainModule {}
